import { TextareaAttachmentType } from '@/common/components/base/textarea/base/CommonInput.type';

const createAttachment = ({
  element,
  size = 'medium',
  shouldRender = true,
}: TextareaAttachmentType): TextareaAttachmentType => {
  return {
    element,
    size,
    shouldRender,
  };
};
export default createAttachment;
